<template>

  <div class="wrapper wrapper-full-page">

      <!-- Navbar -->
      <nav class="navbar navbar-expand-lg navbar-absolute">
          <div class="container">
              <div class="navbar-wrapper">
                  <a class="navbar-brand" href="#pablo">Light Bootstrap Dashboard Pro</a>
                  <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
                      <span class="navbar-toggler-bar burger-lines"></span>
                      <span class="navbar-toggler-bar burger-lines"></span>
                      <span class="navbar-toggler-bar burger-lines"></span>
                  </button>
              </div>
              <div class="collapse navbar-collapse justify-content-end" id="navbar">
                  <ul class="navbar-nav">
                      <li class="nav-item">
                          <a href="../dashboard.html" class="nav-link">
                              <i class="nc-icon nc-chart-pie-35"></i> Dashboard
                          </a>
                      </li>
                      <li class="nav-item ">
                          <a href="register.html" class="nav-link">
                              <i class="nc-icon nc-badge"></i> Register
                          </a>
                      </li>
                      <li class="nav-item  active ">
                          <a href="login.html" class="nav-link">
                              <i class="nc-icon nc-mobile"></i> Login
                          </a>
                      </li>
                      <li class="nav-item ">
                          <a href="lock.html" class="nav-link">
                              <i class="nc-icon nc-key-25"></i> Lock
                          </a>
                      </li>
                  </ul>
              </div>
          </div>
      </nav>
      <!-- End Navbar -->
      <div class="full-page  section-image" data-color="black" data-image="assets/img/login-background.jpg" ;>
          <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
          <div class="content">
              <div class="container">
                  <div class="col-md-4 col-sm-6 ml-auto mr-auto">
                      <form class="form" method="" action="">
                          <div class="card card-login card-hidden">
                              <div class="card-header ">
                                  <h3 class="header text-center">Login</h3>
                              </div>
                              <div class="card-body ">
                                  <div class="card-body">
                                      <div class="form-group">
                                          <label>Email address</label>
                                          <input type="email" placeholder="Enter email" class="form-control">
                                      </div>
                                      <div class="form-group">
                                          <label>Password</label>
                                          <input type="password" placeholder="Password" class="form-control">
                                      </div>
                                      <div class="form-group">
                                          <div class="form-check">
                                              <label class="form-check-label">
                                                  <input class="form-check-input" type="checkbox" value="" checked>
                                                  <span class="form-check-sign"></span>
                                                  Subscribe to newsletter
                                              </label>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="card-footer ml-auto mr-auto">
                                  <button type="submit" class="btn btn-warning btn-wd">Login</button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>

  </div>



</template>

<script>
  import router from '../../router'
  import apiService from '../../services/api.service'
  import config from '../../config'

  import "../../../static/js/jquery.dataTables.min.js"


  export default {
    name: 'Demo',
    data: function() {
      return {
        user: '',
        password: '',
        myname: 'Timmyy',
      }
    },
    mounted: function() {
      console.log("mounted------");
      initTables();
    },

    methods: {


    }
  }

  function initTables() {

    var vm = this;
    console.log( "test: " + $("#test").html() );


    var testdata = {
      "data": [
        {
          "customer": "John James",
          "shipper": "Pat Crossman",
          "consignee": "Jimmy C. Gerry",
          "created_date": "Mon Dec 18, 2017",
          "due_date": "Mon Dec 28, 2017",
          "status": '<strong>Assigned <i class="fa fa-square rfq_received"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
        {
          "customer": "John James II",
          "shipper": "Pat Crossman II",
          "consignee": "Jimmy C. Gerry II",
          "created_date": "Mon Dec 18, 2018",
          "due_date": "Mon Dec 28, 2018",
          "status": '<strong>Assigned <i class="fa fa-square rfq_declined"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
        {
          "customer": "Brian G. Baldree",
          "shipper": "Pat Crossman II",
          "consignee": "Jimmy C. Gerry II",
          "created_date": "Mon Dec 18, 2018",
          "due_date": "Mon Dec 28, 2018",
          "status": '<strong>Assigned <i class="fa fa-square rfq_viewed"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
      ]};



    var mytable = $('#datatables').DataTable({
         "data": testdata.data,
         "columns": [
             {
                 "className": 'details-control',
                 "orderable": false,
                 "defaultContent": '',
                 "render": function () {
                     return '<i class="fa fa-plus-square" aria-hidden="true"></i>';
                 },
             },
             { "data": "customer" },
             { "data": "shipper" },
             { "data": "consignee" },
             { "data": "created_date" },
             { "data": "due_date" },
             { "data": "status" },
             { "data": "actions", "className": 'text-right' },
         ],

        "pagingType": "full_numbers",
        "lengthMenu": [
            [10, 25, 50, -1],
            [10, 25, 50, "All"]
        ],
        retrieve: true,
        responsive: true,
        language: {
            search: "_INPUT_",
            searchPlaceholder: "Search records",
        }

    });


    // Add event listener for opening and closing details
    $('#datatables tbody').on('click', 'td.details-control', function () {
        var tr = $(this).closest('tr');
        var row = mytable.row(tr);
        var tdi = tr.find("i.fa");

        if ( row.child.isShown() ) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            tdi.first().removeClass('fa-minus-square');
            tdi.first().addClass('fa-plus-square');

        }
        else {
            // Open this row
            row.child( formatDetailRow(row.data()) ).show();
            tr.addClass('shown');
            tdi.first().removeClass('fa-plus-square');
            tdi.first().addClass('fa-minus-square');
            // setTimeout( function() { tr.next().find("td").attr("colspan", "15").attr("width", "100%") }, 1000);
        }
    } );

    console.log("datatables init done!");
  }

  // https://datatables.net/examples/api/row_details.html
  function formatDetailRow ( d ) {

    // d is the original data object for the row
    // console.log( JSON.stringify(d) );

    return '<table class="table">'+
      '<thead>'+
          '<tr>'+
            '<th>Assignee</th>'+
            '<th>Assign Data</th>'+
            '<th>Due Date</th>'+
            '<th>Status</th>'+
            '<th>Total Quote</th>'+
            '<th class="text-right">Actions</th>'+
          '</tr>'+
      '</thead>'+
      '<tbody>'+
        '<tr>'+
          '<td>Eva Solomon</td>'+
          '<td>Mon Dec 18, 2017</td>'+
          '<td>Tue Dec 19, 2017</td>'+
          '<td>Open</td>'+
          '<td>$500.00</td>'+
          '<td class="text-right"><a href="#" class="btn btn-link btn-primary"><i class="fa fa-fw fa-plus"></i></a></td>'+
        '</tr>'+
      '</tbody>'+
    '</table>';

    /*
    return "colspan all of this now";


    return [
        'First child row',
        'Second child row',
        'Third child row'
    ];*/

  }


  // https://vuejsdevelopers.com/2017/04/22/vue-js-libraries-plugins/
  // https://laracasts.com/discuss/channels/vue/using-datatables-with-vue


</script>



// WEBPACK FOOTER //
// t_login.vue?ad9c9620